export default __webpack_public_path__ + "0f19cbdf0afc4ec04674439e5fda09d5.svg";